import React from 'react'
import { buildClassName } from '@vero/ui-core-browser/utils.js'
import useActiveCompany from '@vero/ui-core-browser/hooks/active-company.js'

export default function ({ className }) {
  const { activeCompany, resetActiveCompany } = useActiveCompany()
  const pathname = window.location.pathname

  return (
    <ul className={buildClassName(['menu menu-lg bg-base-100 min-h-full w-max font-light uppercase', className])}>
      <li>
        <a href={`/auth/select-company?r=${pathname}`} onClick={resetActiveCompany}>{activeCompany?.slug ? 'switch' : 'select'} company</a>
      </li>
      <li>
        <a href='/auth/change-password'>change password</a>
      </li>
      <li>
        <a href={`/api/auth/logout?redirect_uri=${window.location.origin}/auth/login?r=${pathname}`}>sign out</a>
      </li>
    </ul>
  )
}
